import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import "./../node_modules/bootstrap-css-only/css/bootstrap.min.css";
import Root from "./containers/Root";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { createHashHistory } from "history";
import { routerMiddleware } from "react-router-redux";
import rootReducer from "./reducers";
import createPromiseMiddleware from "./store/promise_middleware";

const history = createHashHistory();
const router = routerMiddleware(history);
const enhancer = applyMiddleware(thunk, router, createPromiseMiddleware());

function configureStore(initialState) {
  return createStore(rootReducer, initialState, enhancer);
}
const store = configureStore();
render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
